import {useEffect, useState} from "react";
import './vacancy-detail.scss';
import {
    FacebookIcon,
    ImgMembership,
    InstagramIcon,
    InstagramVacancyIcon,
    LinkedinIcon, TelegramIcon,
    TicTokIcon
} from "../../../assets/images";
import {useContact} from "../../../graphql/query.hooks/contact.hook";
import {useTranslations} from "../../../graphql/query.hooks/translation.hook";
import VacancyApplyModal from "../../../components/uiElements/modals/vacancyApplyModal/VacancyApplyModal";
import {Link, useParams} from "react-router-dom";
import {GetUrlWithLocal} from "../../../utils/getUrlWithLocal";
import {useVacancyOne} from "../../../graphql/query.hooks/vacancyOne.hook";

export default function VacancyDetail({vacancy}){
    const contact = useContact()
    const params = useParams()
    const vacancyOne = useVacancyOne(params?.id)
    const translations = useTranslations()
    const [vacancyModalOpen, setVacancyModalOpen] = useState(false);

    function openVacancyModal() {
        setVacancyModalOpen(true)
    }
    function closeVacancyModal() {
        setVacancyModalOpen(false)
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
        });
    }, [])


    console.log(contact,'contactcontact');
    return <div className={'vacancy_detail_wrapper'}>
        <div className={'top'}/>
        <div className={'vacancy_nav_block'}>
            <Link to={GetUrlWithLocal('/vacancy')} className={'nav_vacancy_item'}>{translations?.vacancy_menu_title} ›</Link>
            <div className={'nav_vacancy_slug'}>
                {vacancyOne?.data?.title}
            </div>
        </div>
        <div className={'vacancy_info_blocks'}>
            <div className={'vacancy_left_wrapper'}>
                <img src={ImgMembership} alt=""/>

                <div className={'vacancy_left_wrapper_title'}>
                    {translations?.vacancy_detail_title || 'We are always here, waiting for you '}
                </div>
                <div className={'vacancy_social_medias'}>
                    <a href={contact?.list?.fb_link} target={'_blank'}>
                        <FacebookIcon/>
                    </a>
                    <a href={contact?.list?.in_link} target={'_blank'}>
                        <LinkedinIcon/>
                    </a>
                    <a href={contact?.list?.tk_link} target={'_blank'}>
                        <TicTokIcon/>
                    </a>
                    <a href={contact?.list?.tg_link} target={'_blank'}>
                        <TelegramIcon/>
                    </a>
                    <a href={contact?.list?.in_link} target={'_blank'}>
                        <InstagramVacancyIcon/>
                    </a>
                </div>
                <div className={'address_vacancy'}>
                    <div className={'block_title'}>
                        {translations?.contacts_address_title  || ''}
                    </div>
                    <a className={'block_info'}
                       target={"_blank"}
                       href={'https://yandex.ru/maps/org/oranzh_fitnes/1698075629/?ll=44.488028%2C40.183321&z=16.8'}>
                        {contact?.list?.address}
                    </a>
                </div>
                <div className={'vacancy_working_hours'}>
                    <div className={'block_title'}>
                        {translations?.contact_working_hour_title}
                    </div>
                    <div className={'block_info'}
                         dangerouslySetInnerHTML={{ __html: contact?.list?.working_times }}/>
                </div>
                <div className={'vacancy_phone_number'}>
                    <div className={'block_title'}>
                        {translations?.contact_number_title}
                    </div>
                    <div className={'block_info'}
                         dangerouslySetInnerHTML={{ __html: contact?.list?.phones }}/>
                </div>
                {
                    contact?.list?.email && <div className={'vacancy_email_block'}>
                        <div className={'block_title'}>
                            {translations?.contact_email_title}
                        </div>
                        <div className={'block_info'}>
                            {contact?.list?.email}
                        </div>
                    </div>
                }
            </div>
            <div className={'vacancy_right_wrapper'}>
                <div className={'vacancy_detail_title'}>
                    {vacancyOne?.data?.title}
                </div>
                <div className={'vacancy_apply_btn'} onClick={openVacancyModal}>
                    {translations?.vacancy_apply_btn}
                </div>
                <pre className={'vacancy_detail_description'}>
                    {vacancyOne?.data?.description}
                </pre>
            </div>
        </div>

        {vacancyModalOpen && <VacancyApplyModal visible={vacancyModalOpen}
                                                vacancyId={vacancyOne?.data?.id}
                                                vacancyCV={vacancyOne?.data?.cvIsRequired}
                                                closeModal={closeVacancyModal}/>}
    </div>
}